'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactComponentWithPureRenderMixin = require('react/lib/ReactComponentWithPureRenderMixin');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageClick = _react2.default.createClass({
  displayName: 'PageClick',

  propTypes: {
    children: _react2.default.PropTypes.node.isRequired,
    onClick: _react2.default.PropTypes.func.isRequired,
    outsideOnly: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      outsideOnly: true
    };
  },
  componentWillMount: function componentWillMount() {
    this.insideClick = false;
  },
  componentDidMount: function componentDidMount() {
    global.window.addEventListener('mousedown', this.onDocumentClick, false);
  },


  shouldComponentUpdate: _ReactComponentWithPureRenderMixin.shouldComponentUpdate,

  componentWillUnmount: function componentWillUnmount() {
    global.window.removeEventListener('mousedown', this.onDocumentClick, false);
  },
  onDocumentClick: function onDocumentClick() {
    var _props;

    if (this.insideClick) {
      return;
    }
    (_props = this.props).onClick.apply(_props, arguments);
  },
  onMouseDown: function onMouseDown() {
    this.insideClick = true;
  },
  onMouseUp: function onMouseUp() {
    this.insideClick = false;
  },
  render: function render() {
    var props = this.props.outsideOnly ? {
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp
    } : {};

    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  }
});

exports.default = PageClick;
//# sourceMappingURL=PageClick.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-page-click/lib/PageClick.js
 ** module id = 920
 ** module chunks = 0
 **/